const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconPag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.16 20.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.66,20.16H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0H19.66a.5.5,0,0,1,.5.5V19.66A.5.5,0,0,1,19.66,20.16ZM1,19.16H19.16V1H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.66,5.32H.5a.5.5,0,0,1,0-1H19.66a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.09,3.15H15.8a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.29a.5.5,0,0,1,.5.5A.51.51,0,0,1,18.09,3.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPag);
export default __webpack_public_path__ + "static/media/icon_pag.5d021e41915a8542f89b2c0ee174a918.svg";
export { ForwardRef as ReactComponent };